import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '/more/discover_profiles/mum_and_baby.jpg'
import _imports_1 from '/more/discover_profiles/boy.jpg'


const _hoisted_1 = { class: "space-y-16" }
const _hoisted_2 = { class: "bg-gradient-to-br from-blue-50 to-indigo-100 dark:from-blue-900/20 dark:to-indigo-900/30 rounded-2xl p-8" }
const _hoisted_3 = { class: "text-center space-y-8" }
const _hoisted_4 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" }
const _hoisted_5 = { class: "text-center space-y-3" }
const _hoisted_6 = { class: "w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center mx-auto" }
const _hoisted_7 = { class: "text-center space-y-3" }
const _hoisted_8 = { class: "w-12 h-12 bg-green-500 rounded-full flex items-center justify-center mx-auto" }
const _hoisted_9 = { class: "text-center space-y-3" }
const _hoisted_10 = { class: "w-12 h-12 bg-purple-500 rounded-full flex items-center justify-center mx-auto" }
const _hoisted_11 = { class: "text-center space-y-3" }
const _hoisted_12 = { class: "w-12 h-12 bg-amber-500 rounded-full flex items-center justify-center mx-auto" }
const _hoisted_13 = { class: "flex flex-col md:flex-row gap-8 w-full mt-8" }

import { Motion } from "motion-v";


export default /*@__PURE__*/_defineComponent({
  __name: 'resident-profiles',
  setup(__props) {

defineOgImage("MainOg", {
  title: "Resident Profiles - Comprehensive Care Documentation",
  description:
    "Create detailed resident profiles with comprehensive care documentation. Track individual journeys, needs, preferences, and care plans in one dedicated space.",
  theme: "#bc9fff",
  colorMode: "light",
});

useSeoMeta({
  title: "Resident Profiles - Comprehensive Care Documentation | FamilyAxis",
  description:
    "Create detailed resident profiles with comprehensive care documentation. Track individual journeys, needs, preferences, and care plans in one dedicated space.",
  keywords:
    "family assessment, family assessment centres, resident profiles, care documentation, individual care plans, resident management, care tracking, personal care records, resident journey",
  author: "FamilyAxis",
  ogTitle: "Resident Profiles - Comprehensive Care Documentation | FamilyAxis",
  ogDescription:
    "Create detailed resident profiles with comprehensive care documentation. Track individual journeys, needs, preferences, and care plans in one dedicated space.",
  ogUrl: "https://familyaxis.com/more/resident-profiles",
  ogType: "website",
  ogSiteName: "FamilyAxis",
  twitterCard: "summary_large_image",
  twitterTitle: "Resident Profiles - Comprehensive Care Documentation | FamilyAxis",
  twitterDescription: "Create detailed resident profiles with comprehensive care documentation.",
  twitterSite: "@familyaxis",
  robots: "index, follow",
});

useHead({
  link: [{ rel: "canonical", href: "https://familyaxis.com/more/resident-profiles" }],
});

const parentFeatures = [
  {
    title: "Progress tracking through the assessment process",
    icon: "i-heroicons-chart-bar",
  },
  {
    title: "Overview of observations, direct work, and reports",
    icon: "i-heroicons-document-text",
  },
  {
    title: "Essential details and emergency contacts",
    icon: "i-heroicons-phone",
  },
  {
    title: "Dedicated health and safeguarding sections",
    icon: "i-heroicons-shield-check",
  },
];

const childFeatures = [
  {
    title: "Essential details and emergency contacts, plus linked parent(s) and assessment status",
    icon: "i-heroicons-user",
  },
  {
    title: "Capture health, development, and additional needs",
    icon: "i-heroicons-heart",
  },
  {
    title:
      "Safeguarding: concerns, incidents, actions taken and a secure chronology to support decisions",
    icon: "i-heroicons-shield-exclamation",
  },
  {
    title:
      "My Story: a flexible area for life-story work and child-centred records (day-in-the-life, memory journals, special people and milestones)",
    icon: "i-heroicons-book-open",
  },
];

return (_ctx: any,_cache: any) => {
  const _component_UPageHero = _resolveComponent("UPageHero")!
  const _component_UPageSection = _resolveComponent("UPageSection")!
  const _component_UIcon = _resolveComponent("UIcon")!
  const _component_LazyShowCaseCard = _resolveComponent("LazyShowCaseCard")!
  const _component_LazyStartSignup = _resolveComponent("LazyStartSignup")!
  const _component_UPageBody = _resolveComponent("UPageBody")!
  const _component_UPage = _resolveComponent("UPage")!
  const _component_UContainer = _resolveComponent("UContainer")!

  return (_openBlock(), _createBlock(_component_UContainer, null, {
    default: _withCtx(() => [
      _createVNode(_component_UPage, { class: "pt-10" }, {
        default: _withCtx(() => [
          _createVNode(_component_UPageHero, {
            title: "Parent & Child Profiles",
            description: "FamilyAxis provides dedicated parent and child profiles in a secure, easy-to-use system, helping staff find what matters fast. Each profile gives professionals a clear, up-to-date picture to support assessment and decision-making, while preserving the personal details that keep families and children at the centre of the work. ",
            ui: {
          container: 'flex flex-col lg:grid py-8 lg:py-10',
        }
          }),
          _createVNode(_component_UPageBody, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_unref(Motion), {
                  as: "div",
                  initial: { opacity: 0, y: 20 },
                  "while-in-view": { opacity: 1, y: 0 },
                  viewport: { once: true },
                  transition: { duration: 0.4, delay: 0.15 },
                  class: "mt-10"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_UPageSection, {
                      id: "topFeature",
                      title: "A clear view of each parent's journey.",
                      description: "Parent profiles help professionals quickly access and update essential information, so they can spend less time searching and more time supporting.",
                      orientation: "horizontal",
                      features: parentFeatures,
                      ui: {
                container: 'flex flex-col lg:grid py-8 lg:py-10',
              }
                    }, {
                      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                        _createElementVNode("div", { class: "space-y-4" }, [
                          _createElementVNode("img", {
                            src: _imports_0,
                            alt: "Mother and baby",
                            class: "rounded-xl w-full h-full object-cover"
                          })
                        ], -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_UPageSection, {
                  title: "A dedicated space for each child's story.",
                  description: "Child profiles bring together practical details and the things that matter most to the child, from medical needs to memories, so staff can keep the child's voice and experience at the centre of every decision. ",
                  orientation: "horizontal",
                  reverse: "",
                  features: childFeatures,
                  ui: {
              container: 'flex flex-col lg:grid py-8 lg:py-10',
            }
                }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createElementVNode("img", {
                      src: _imports_1,
                      alt: "Child",
                      class: "rounded-xl w-full h-full object-cover"
                    }, null, -1)
                  ]))]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "space-y-4" }, [
                      _createElementVNode("h3", { class: "text-2xl font-bold text-gray-900 dark:text-white" }, " Why Profiles Matter "),
                      _createElementVNode("p", { class: "text-gray-600 dark:text-gray-400 max-w-2xl mx-auto" }, " Profiles act as the \"home page\" for each individual, where staff can quickly access information: observations, direct work, safeguarding, reports, and any ongoing forms. ")
                    ], -1)),
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_UIcon, {
                            name: "i-heroicons-eye",
                            class: "w-6 h-6 text-white"
                          })
                        ]),
                        _cache[2] || (_cache[2] = _createElementVNode("h4", { class: "font-semibold text-gray-900 dark:text-white" }, "Clarity", -1)),
                        _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-sm text-gray-600 dark:text-gray-400" }, " Everything in one place — no more scattered notes or lost forms. ", -1))
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_UIcon, {
                            name: "i-heroicons-heart",
                            class: "w-6 h-6 text-white"
                          })
                        ]),
                        _cache[4] || (_cache[4] = _createElementVNode("h4", { class: "font-semibold text-gray-900 dark:text-white" }, "Compassion", -1)),
                        _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-sm text-gray-600 dark:text-gray-400" }, " Keep families' experiences central and their voices heard. ", -1))
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_component_UIcon, {
                            name: "i-heroicons-clock",
                            class: "w-6 h-6 text-white"
                          })
                        ]),
                        _cache[6] || (_cache[6] = _createElementVNode("h4", { class: "font-semibold text-gray-900 dark:text-white" }, "Efficiency", -1)),
                        _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-sm text-gray-600 dark:text-gray-400" }, " Spend less time on paperwork and more time with people. ", -1))
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(_component_UIcon, {
                            name: "i-heroicons-shield-check",
                            class: "w-6 h-6 text-white"
                          })
                        ]),
                        _cache[8] || (_cache[8] = _createElementVNode("h4", { class: "font-semibold text-gray-900 dark:text-white" }, "Safeguarding", -1)),
                        _cache[9] || (_cache[9] = _createElementVNode("p", { class: "text-sm text-gray-600 dark:text-gray-400" }, " Ensure important concerns are visible and actionable. ", -1))
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_LazyShowCaseCard, {
                  title: "Direct Work",
                  description: "Customise and track direct work sessions.",
                  icon: "i-heroicons-academic-cap",
                  image: "/images/dw_track.svg",
                  "image-position": "bottom",
                  link: "/more/direct-work",
                  class: "w-full md:w-3/7 h-110"
                }),
                _createVNode(_component_LazyShowCaseCard, {
                  title: "Progress & Observations",
                  description: "Log observations and track progress against assessment goals.",
                  icon: "i-heroicons-chart-bar-square",
                  image: "/images/obs_track.svg",
                  "image-position": "bottom",
                  link: "/more/progress-observations",
                  class: "w-full md:w-4/7 h-110"
                })
              ]),
              _createVNode(_component_LazyStartSignup, {
                title: "Ready to transform your family assessment process?",
                description: "Join assessment centres using FamilyAxis to create comprehensive, person-centred profiles that put families at the heart of their care.",
                "button-label": "Get Started Today"
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})